import React from 'react';
import RideList from './rides/RideList';
import './Dashboard.css';
import './RidesManagementPage.css';

// The "Пътувания" tab. It used to show /analytics/rides, which answers 501
// (not implemented), so the page showed only an error. It now lists every ride
// a driver published; the Табло tab keeps the ride totals.
const RidesManagementPage: React.FC = () => (
  <div className="dashboard">
    <div className="dashboard-header rides-header">
      <div className="header-content">
        <h2>Пътувания</h2>
        <p className="last-updated">Всички пътувания, публикувани от шофьори</p>
      </div>
    </div>
    <RideList />
  </div>
);

export default RidesManagementPage;
